<!-- 资源释放 -->
<template>
  <div class="new-application">
    <el-card class="box-card">
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :disabled="isShow"
          @submit="submit(2)"
          @cancelForm="cancel"
        >
          <div>
            <!-- <div style="margin-left: 50px">{{item.person}}</div> -->
            <el-calendar style="width:80%;margin:0 auto" v-model="month">
              <template
                slot="dateCell"
                slot-scope="{date, data}"
              >
                <div
                  style="width:100%;height:100%;font-size: 14px"
                  @click="pick(date)"
                  :style="dateStyle(data.day)?'background:#FF69B4;color:#ffffff':''"
                >
                  {{ data.day.split('-').slice(1).join('-') }}<br /> {{dealMyDate(data.day)}}
                </div>
              </template>
            </el-calendar>
          </div>
        </dynamic-form>
      </div>
       <div class="button">
        <el-button class="btn-submit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { addRelease, updateRelease,getPersonRelease,getReleaseDetail} from "@/api/bill/resource";
import { parseTime } from "@/utils";
import { getDocumentCode } from "@/views/utils";

export default {
  name: "ResourceAccount",

  data() {
    return {
      id: "",
      isShow: false,
      loading: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            span: 8,
            label: "单据编号",
            key: "code",
            type: "input",
            disabled: true
          },
          {
            label: "人员",
            key: "person",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目名",
            key: "project",
            type: "databox",
            placeholder: "请选择项目",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/resourceApply/getProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { billState: 3, searchType: 1 }, // searchType 1 立项 2项目计划
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目角色",
            key: "projectRole",
            type: "databox",
            placeholder: "请选择项目角色",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bsProjectRoles",
            tableColumn: [
              {
                property: "code",
                label: "项目角色",
                align: "center"
              },
              {
                property: "name",
                label: "角色名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "释放天数",
            key: "releaseDay",
            type: "input",
            span: 8,
            disabled: true
          }
          //  {
          //   type: "calendar",
          //   key: "calendar",
          //   label: "",
          //   value: "",
          //   span: 20,
          // },
        ]
      },
      // 状态
      status: 0,
      personId: "",
      resDate: [], // 已被占用数组
      selectDate: [], // 新增占用数组
      month: parseTime(new Date(), "{y}-{m}")
    };
  },
  created() {
     this.isShow = Boolean(Number(this.$route.query.isShow));
    console.log(this.isShow);
    if (!this.isShow) {
      this.form.code = getDocumentCode("ZYSF");
    } else {
      this.id = this.$route.query.id
      getReleaseDetail(this.id).then(res => {
        console.log(res)
         this.personId = res.data.release.personId;
        this.form.code = res.data.release.code;
        this.form.project = { code: res.data.release.projectId, name: res.data.release.projectName };
        this.form.person = { id: res.data.release.personId, name: res.data.release.personName };
        this.form.projectRole = { code: res.data.release.projectRoles,  name: res.data.release.projectRolesName};
        this.form.releaseDay = res.data.release.releaseDay;
        for (const i of res.data.detailsVos) {
          this.resDate.push({  applyId: i.applyId,  id: i.id,  occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state});
          }
      })
      this.isShow = true;
    }
  },
  computed: {},
  watch: {
    month(newVal, oldVal) {
      if (newVal && !this.id && parseTime(newVal, "{y}-{m}") !== parseTime(oldVal, "{y}-{m}")) {
        // this.resDate = [];
        this.month =  parseTime(newVal, "{y}-{m}")
        getPersonRelease(this.personId, { month: this.month, projectId: this.form.projectId }).then(res => {
            console.log(res);
             if (res.code ===  200 && res.data.apply) {
               this.form.projectRole = { code: res.data.apply.projectRoles, name: res.data.apply.projectRolesName,id: res.data.apply.projectRoles};
               } else {
                  this.form.projectRole = {}
                }
            for (const i of res.data.details) {
               for (const o of this.selectDate) { // 月份切换保持展示数据中有新增的数据的状态不变
                if (i.id === o.id) {
                  i.state = o.state;
                }
              }
              this.resDate.push({  applyId: i.applyId,  id: i.id,  occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state});
            }
          });
      }
    },
    "form.project": {
      handler(val,oldVal) {
        console.log(val);
        if (val && !this.id && val !== oldVal) {
          this.form.projectName = this.form.project.name;
          this.form.projectId = this.form.project.id;
          this.resDate = [];
          this.selectDate = []
          this.form.releaseDay = 0;
           getPersonRelease(val.id, { month: this.month, projectId: this.form.projectId }).then(res => {
            console.log(res);
             if (res.code ===  200 && res.data.apply) {
               this.form.projectRole = { code: res.data.apply.projectRoles, name: res.data.apply.projectRolesName,id: res.data.apply.projectRoles};
               } else {
                  this.form.projectRole = {}
                }
            for (const i of res.data.details) {
              this.resDate.push({  applyId: i.applyId,  id: i.id,  occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state});
            }
          });
        }
      },
      deep: true
    },
    "form.person": {
      handler(val) {
        console.log(val);
        if (val  && !this.id) {
           this.personId = val.id;
           this.resDate = [];
           this.selectDate = []
           this.form.releaseDay = 0;
          getPersonRelease(val.id, { month: this.month, projectId: this.form.projectId }).then(res => {
            console.log(res);
             if (res.code ===  200 && res.data.apply) {
               this.form.projectRole = { code: res.data.apply.projectRoles, name: res.data.apply.projectRolesName,id: res.data.apply.projectRoles};
               } else {
                  this.form.projectRole = {}
                }
            for (const i of res.data.details) {
              this.resDate.push({  applyId: i.applyId,  id: i.id,  occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state});
            }
          });
        }
      },
      deep: true
    }
  },
  methods: {
    // 日历选中
    //  pick(data) {
    //   const curDate = parseTime(data, "{y}-{m}-{d}");
    //   if (new Date(data).getTime() < new Date().getTime()) {
    //    return this.$notify({ title: "今天之前的日期不可以选择！", type: "error", duration: 2500 });
    //   } else {
    //     this.resDate = this.resDate.map(i => {
    //       if (i.occupyDate === curDate && i.state === 1) {
    //         const index = this.selectDate.findIndex(item => {  return item.id === i.id; });
    //           if (index === -1) {
    //             this.selectDate.push({applyId: i.applyId, id: i.id, occupyDate: curDate, projectName: this.form.project.name, state: 0 })
    //             i.state = 2;
    //             return i;
    //             } else  {
    //                this.selectDate.splice(index,1)
    //                i.state = 1
    //                return i;
    //             }
    //       } else {
    //         return this.$notify({ title: "无需释放！", type: "error", duration: 2500 });
    //       }
    //       // return i;
    //     });
    //      this.form.releaseDay =  this.selectDate.length;
    //   }
    // },
    pick(data) {
      const curDate = parseTime(data, "{y}-{m}-{d}");
      const now = parseTime(new Date(), "{y}-{m}-{d}");
      if (Date.parse(curDate.replace(/\-/g,'/')) < Date.parse(now.replace(/\-/g,'/')) && !this.id) {
       return this.$notify({ title: "今天之前的日期不可以选择！", type: "error", duration: 2500 });
      } else {
        this.resDate = this.resDate.map(i => {
            // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
          if (i.occupyDate === curDate) {
            if (this.form.projectName === i.projectName && i.state === 1 && !this.id) {
              const index = this.selectDate.findIndex(item => {  return item.id === i.id; });
              if (index === -1) {
                this.selectDate.push({applyId: i.applyId, id: i.id, occupyDate: curDate, projectName: this.form.project.name, state: 2 })
                }
                i.state = 2;
            } else {
              if (!this.id) {
                i.state = 1
                const index = this.selectDate.findIndex(item => {  return item.id === i.id; });
                this.selectDate.splice(index,1)
              }
            }
          }
          return i;
        });
        if (!this.id) {
           this.form.releaseDay =  this.selectDate.length;
        }
      }
    },
    // 日历样式
    dateStyle(date) {
      let flag = false;
      for (const i of this.resDate) {
        // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
        if (i.occupyDate === date && i.state === 1) {
          flag = true;
        }
      }
      return flag;
    },
    // 日历展示的内容
    dealMyDate(v) {
      let res = "";
      for (const i of this.resDate) {
        // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
        if (i.occupyDate === v && i.state === 0) {
          res = i.projectName + "√";
        } else if (i.occupyDate === v && i.state === 1) {
          res = i.projectName;
        } else if (i.occupyDate === v && i.state === 2) {
          res = i.projectName + "×";
        } else if (i.occupyDate === v && i.state === 3) {
          res = i.projectName + "○";
        } else if (i.occupyDate === v && i.state === 4) {
          res = i.projectName;
        }
      }
      return res;
    },
    submit(status) {
       this.loading = true;
      this.form.billState = status;
      this.form.personId = this.form.person.id;
      this.form.projectId = this.form.project.id;
      this.form.projectRoles = this.form.projectRole.code;
      this.form.releaseDay = this.selectDate.length;
      const obj = {};
      // obj.applyVo = {}
      obj.release = this.form;
      obj.detailsList = this.selectDate;
      console.log(obj)
      if (!this.form.projectRoles) {
        return this.$notify({ title: "请选择项目角色~", type: "error", duration: 2500 });
      }
       if (obj.detailsList.length <= 0 || !this.form.personId || !this.form.projectId) {
        return this.$notify({ title: "数据不全~", type: "error",  duration: 2500 });
      }
      this.pull(obj);
    },
    cancel() {
      this.$router.go(-1);
    },
    pull(data) {
      if (this.id) {
        updateRelease(data).then(res => {
           this.loading = false;
          if (res.code === 200) {
            this.selectDate = [];
            this.$notify({
              title: "提交成功！",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      } else {
        addRelease(data).then(res => {
           this.loading = false;
          if (res.code === 200) {
            this.$notify({
              title: "提交成功！",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
</style>
